import { useState, useMemo, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {Container, Stack, Col, Button, Modal, Form} from "react-bootstrap";
import TarjetaAtencion from "./TarjetaAtencion";
import ComentarioNuevo from "./ComentarioNuevo";
import AtencionesControles from "./AtencionesControles";
import BotonDescargarFicha from "./BotonDescargarFicha";
import {
  agregarComentario,
  finalizarAtencion,
  descartarAtencion,
  crearAtencionManual,
  anularAtencion,
} from "../../services/apis_funcionarios";
import Boton from "../estudiantes/Boton";
import { getMotivosEstudiante } from "../../services/apis_estudiante";

const styles = {
  container: {
    backgroundColor: "var(--color-background-3)",
    height: "100%",
    width: "100%",
  },
  scrollable: {
    overflowY: "auto",
    maxHeight: "60vh",
  },
  btnPrimary: {
    backgroundColor: "var(--color-accent)",
    border: "none",
  },
};

function HistorialAtenciones({
  idS,
  atenciones,
  atencionActual,
  controles = false,
  botones = false,
  onRefresh,
}) {
  const navigate = useNavigate();
  const [canFinalize, setCanFinalize] = useState(atencionActual !== null);
  const [canAddComment, setCanAddComment] = useState(
    atencionActual == null ? false : atencionActual.descripcion == ""
  );
  const [filtroMotivo, setFiltroMotivo] = useState("Todos");
  const [orden, setOrden] = useState("desc");
  const [showComentario, setShowComentario] = useState(true);
  const [showFinalizeModal, setShowFinalizeModal] = useState(false);

  const [motivoNuevo, setMotivoNuevo] = useState("");
  const [comentarioNuevo, setComentarioNuevo] = useState("");

  const [showCrearModal, setShowCrearModal] = useState(false);
  const [motivosDisponibles, setMotivosDisponibles] = useState([]);
  const [motivoManual, setMotivoManual] = useState("");
  const [comentarioManual, setComentarioManual] = useState("");
  const [guardandoManual, setGuardandoManual] = useState(false);

  const [showAnularModal, setShowAnularModal] = useState(false);
  const [atencionAAnular, setAtencionAAnular] = useState(null);
  const [motivoAnulacion, setMotivoAnulacion] = useState("");
  const [anulando, setAnulando] = useState(false);

  useEffect(() => {async function cargarMotivos() {
    try { const motivos = await getMotivosEstudiante();
         setMotivosDisponibles(motivos);
         
         if (motivos.length > 0) { setMotivoManual(String(motivos[0].id));
                                 }
        } catch (error) {
      console.error("No se pudieron cargar los motivos:", error);
    }
  }
                   cargarMotivos();
                  }, []);

  // Motivos únicos
  const motivos = useMemo(() => {
    const lista = atenciones.map((at) => at.motivo);
    return ["Todos", ...new Set(lista)];
  }, [atenciones]);

  // Filtrar + ordenar
  const atencionesProcesadas = useMemo(() => {
    let resultado = [...atenciones];

    // Excluir la atención actual si aun no tiene comentario
    resultado = resultado.filter((at) => {
      const esAtencionActual = at.idAt === atencionActual?.idAt;
      const descripcionVacia = at.descripcion === "";

      return !(esAtencionActual && descripcionVacia);
    });

    // Filtro por motivo
    if (filtroMotivo !== "Todos") {
      resultado = resultado.filter((at) => at.motivo === filtroMotivo);
    }

    // Ordenar por horaInicio
    resultado.sort((a, b) => {
      const fechaA = new Date(a.horaInicio);
      const fechaB = new Date(b.horaInicio);
      return orden === "asc" ? fechaA - fechaB : fechaB - fechaA;
    });

    return resultado;
  }, [filtroMotivo, orden, atenciones, atencionActual]);

  // maneja el guardado de el motivo y el comentario
  const handleSave = async () => {
    try {
      const idAtencion = atencionActual.idAt;
      const mensaje = await agregarComentario(idAtencion, {
        comentario: comentarioNuevo,
        motivo: motivoNuevo,
      });
      onRefresh(); // Aquí se llama a la función que obtendrá los datos nuevamente

      setCanAddComment(false);
      setCanFinalize(true);
      setShowComentario(false);
    } catch (error) {
      console.error("No se pudo guardar el comentario:", error);
      alert("Hubo un error al guardar el comentario. Intenta nuevamente.");
    }
  };

  const handleDescartar = async () => {
    if (!atencionActual?.idAt) {
      console.warn("No hay atención activa para descartar.");
      return;
    }

    try {
      await descartarAtencion(atencionActual.idAt);
      
      // Actualizar estados
      setCanFinalize(false);
      setCanAddComment(false);
      setShowComentario(false);
      
      // Refrescar los datos
      if (onRefresh) {
        onRefresh();
      }
      
      // Redirigir a la página de atención
      navigate("/atencion");
    } catch (err) {
      console.error("Error descartando atención:", err);
      alert("Hubo un error al descartar la atención. Intenta nuevamente.");
    }
  };

  // maneja el apretar el boton de finalizar atencion, solo despliega modal y actualiza estados
  const handleFinalize = async (comentario, motivo) => {
    setComentarioNuevo(comentario);
    setMotivoNuevo(motivo);
    setShowFinalizeModal(true);
    setCanFinalize(false);
  };

  // maneja el confirmar el finalizar atencion en el modal
  const confirmFinalize = async () => {
    if (!atencionActual?.idAt) {
      console.error("ID de atención no disponible.");
      return;
    }
    try {
      const idActual = atencionActual.idAt;
      // Agregar comentario y motivo
      await agregarComentario(idActual, {
        comentario: comentarioNuevo,
        tipo: motivoNuevo,
      });
      // Finalizar atención
      await finalizarAtencion(idActual);
      // setCanFinalize(false);
      // setCanAddComment(false);
      // setShowFinalizeModal(false);
      navigate(`/atencion`);
    } catch (error) {
      console.error("No se pudo finalizar la atención:", error);
      onRefresh(); // Refresca las atenciones si falla finalizar
    }
  };

  // maneja el cancelar el finalizar atencion en el modal
  const cancelFinalize = () => {
    setShowFinalizeModal(false);
    setCanFinalize(true);
  };

  //maneja la edicion de un comentario en una atencion previa
  const handleEditComentario = async (nuevoComentario, idAtencion) => {
    try {
      const mensaje = await agregarComentario(idAtencion, {
        comentario: nuevoComentario,
      });
    } catch (error) {
      console.error("Error al editar comentario:", error);
    }
    onRefresh(); // Refresca las atenciones después de editar el comentario
  };
  
  const handleCrearAtencionManual = async () => {
    if (!motivoManual) {
      alert("Debes seleccionar un motivo.");
      return;
    }
    
    try {
      setGuardandoManual(true);
      
      await crearAtencionManual(idS, {
        motivo: Number(motivoManual),
        comentario: comentarioManual.trim(),
      });
      setShowCrearModal(false);
      setComentarioManual("");
      
      await onRefresh();
    } catch (error) {
      alert(error.message);
    } finally {
      setGuardandoManual(false);
    }
  };
  
  const handleSolicitarAnulacion = (atencion) => {
    setAtencionAAnular(atencion);
    setMotivoAnulacion("");
    setShowAnularModal(true);
  };
  
  const handleConfirmarAnulacion = async () => {
    if (motivoAnulacion.trim().length < 5) {
      alert("Debes indicar por qué se anula la atención.");
      return;
    }
    
    try {
      setAnulando(true);
      
      await anularAtencion(
        atencionAAnular.idAt,
        motivoAnulacion.trim()
      );
      
      setShowAnularModal(false);
      setAtencionAAnular(null);
      setMotivoAnulacion("");
      
      await onRefresh();
    } catch (error) {
      alert(error.message);
    } finally {
      setAnulando(false);
    }
  };
  
  return (
    <Container fluid className="rounded p-4" style={styles.container}>
      {/* Header con titulo y botones */}
      <Stack direction="horizontal" gap={3} className="mb-2 align-items-center">
        <h4 className="m-0">Atenciones</h4>
        <BotonDescargarFicha idS={idS} size={25} />
        <Button size="sm" className="ms-auto btn-primary-blue" onClick={() => setShowCrearModal(true)}>
          <i className="bi bi-plus-lg me-1"></i>
          Agregar ficha
        </Button>
      </Stack>

      <Stack gap={3}>
        {/* Controles de filtro y orden opcionales*/}
        {controles && (
          <Col md={{ span: 8, offset: 4 }}>
            <AtencionesControles
              motivos={motivos}
              motivoSeleccionado={filtroMotivo}
              onChangeMotivo={setFiltroMotivo}
              orden={orden}
              onChangeOrden={setOrden}
            />
          </Col>
        )}

        {/* Tarjeta con input de nuevo comentario*/}
        {showComentario && canAddComment && (
          <ComentarioNuevo
            atencion={atencionActual}
            handleFinalizarAtencion={handleFinalize}
            handleDescartar={handleDescartar}
          />
        )}

        {/* Listado de atenciones previas*/}
        <div style={styles.scrollable} className="mt-2">
          <Stack gap={2}>
            {atencionesProcesadas.length > 0 ? (
              atencionesProcesadas.map((atencion) => (
                <TarjetaAtencion
                  key={atencion.idAt}
                  atencion={atencion}
                  handleEditComentario={handleEditComentario}
                  handleSolicitarAnulacion={handleSolicitarAnulacion}
                  />
              ))
            ) : (
              <p>No hay atenciones registradas.</p>
            )}
          </Stack>
        </div>
      </Stack>
      <Modal
  show={showCrearModal}
  onHide={() => setShowCrearModal(false)}
  centered
>
  <Modal.Header closeButton>
    <Modal.Title>Agregar ficha manual</Modal.Title>
  </Modal.Header>

  <Modal.Body>
    <Form.Group className="mb-3">
      <Form.Label>Motivo</Form.Label>

      <Form.Select
        value={motivoManual}
        onChange={(e) => setMotivoManual(e.target.value)}>
        {motivosDisponibles.map((motivo) => (
          <option key={motivo.id} value={motivo.id}>
            {motivo.nombre}
          </option>
        ))}
      </Form.Select>
    </Form.Group>

    <Form.Group>
      <Form.Label>Comentario</Form.Label>

      <Form.Control
        as="textarea"
        rows={5}
        value={comentarioManual}
        onChange={(e) => setComentarioManual(e.target.value)}
        placeholder="Describa el antecedente que desea registrar"
      />
    </Form.Group>
  </Modal.Body>

  <Modal.Footer>
    <Button
      variant="secondary"
      onClick={() => setShowCrearModal(false)}
      disabled={guardandoManual}
    >
      Cancelar
    </Button>

    <Button
      className="btn-primary-blue"
      onClick={handleCrearAtencionManual}
      disabled={guardandoManual}
    >
      {guardandoManual ? "Guardando..." : "Guardar ficha"}
    </Button>
  </Modal.Footer>
</Modal>
      
      <Modal
        show={showCrearModal}
        onHide={() => setShowCrearModal(false)}
        centered
        >
        <Modal.Header closeButton>
          <Modal.Title>Agregar ficha manual</Modal.Title>
        </Modal.Header>
        
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Motivo</Form.Label>
            
            <Form.Select
              value={motivoManual}
              onChange={(e) => setMotivoManual(e.target.value)}
              >
              {motivosDisponibles.map((motivo) => (
                <option key={motivo.id} value={motivo.id}>
                  {motivo.nombre}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
          
          <Form.Group>
            <Form.Label>Comentario</Form.Label>
            
            <Form.Control
              as="textarea"
              rows={5}
              value={comentarioManual}
              onChange={(e) => setComentarioManual(e.target.value)}
              placeholder="Describa el antecedente que desea registrar"
              />
          </Form.Group>
        </Modal.Body>
        
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowCrearModal(false)}
            disabled={guardandoManual}
            >
            Cancelar
          </Button>
          
          <Button className="btn-primary-blue"
            onClick={handleCrearAtencionManual}
            disabled={guardandoManual}
            >
            {guardandoManual ? "Guardando..." : "Guardar ficha"}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showAnularModal}
        onHide={() => setShowAnularModal(false)}
        centered
        >
        
        <Modal.Header closeButton>
          <Modal.Title>Anular atención</Modal.Title>
        </Modal.Header>
        
        <Modal.Body>
          <p>
            La atención no se eliminará definitivamente. Quedará registrada
            como anulada para conservar la trazabilidad.
          </p>
          
          <Form.Group>
            <Form.Label>Motivo de anulación</Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              value={motivoAnulacion}
              onChange={(e) => setMotivoAnulacion(e.target.value)}
              placeholder="Ejemplo: ficha registrada en el estudiante equivocado"
              />
          </Form.Group>
        </Modal.Body>
        
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowAnularModal(false)}
            disabled={anulando}
            >
            Cancelar
          </Button>
          
          <Button
            variant="danger"
            onClick={handleConfirmarAnulacion}
            disabled={anulando}
            >
            {anulando ? "Anulando..." : "Confirmar anulación"}
          </Button>
        </Modal.Footer>
      </Modal>
      
      {/* Modal de confirmacion para finalizar atencion */}
      <Modal show={showFinalizeModal} onHide={cancelFinalize} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirmar Finalizar Atención</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          ¿Estás seguro que deseas finalizar esta atención? No podrás revertir
          esta acción.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={cancelFinalize}>
            Cancelar
          </Button>
          <Button onClick={confirmFinalize} variant="danger">
            Finalizar
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
}

export default HistorialAtenciones;
